import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { ListadoIngresos } from "./components/ListadoIngresos";
import "./styles/IngresosAlmacen.css";

class IngresosAlmacen extends Component {
    state = {
        almacenInventarioId: null,
        regresar: false,
    };

    componentWillMount() {
        this.setState({ almacenInventarioId: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    // La misma pantalla sirve para el almacén propio y para consultar el de otro
    // acopio; la ruta por la que se entró define si se permite trasladar
    esSoloLectura = () => {
        return this.props.match.path.includes("/otros-acopios/");
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="right-arrow-v2"
                    titulo="Ingresos a almacén"
                    subtitulo=""
                    noBorder
                >
                    <ListadoIngresos
                        regresar={this.regresar}
                        almacenInventarioId={this.state.almacenInventarioId}
                        soloLectura={this.esSoloLectura()}
                    />
                </Card>
            </div>
        );
    }
}

export default IngresosAlmacen;
